// extracted by mini-css-extract-plugin
export default {"apPdpPage":"apPdpPage__vrdyf","apPdpPageTitle":"apPdpPageTitle__11GXO","apPdpPageText":"apPdpPageText__I1NUb"};